<template>
  123
  <div class="card flex justify-center">
    <Button label="Verify" />
  </div>

  <DatePicker v-model="icondisplay" showIcon fluid iconDisplay="input" />
  <DatePicker v-model="templatedisplay" showIcon fluid iconDisplay="input" timeOnly>
    <template #inputicon="slotProps">
      <i class="pi pi-clock" @click="slotProps.clickCallback" />
    </template>
  </DatePicker>
</template>

<script setup></script>
